import ApplicationController from '../application_controller'
import consumer from 'channels/consumer'
import { get } from '@rails/request.js'

class SidebarController extends ApplicationController {
  static values = {
    id: String
  }

  connect () {
    const candidateId = this.idValue
    this.subscription = consumer.subscriptions.create(
      { channel: 'Candidates::ProcessChannel', candidate_id: this.idValue },
      {
        received (data) {
          get(`/candidates/${candidateId}/`, { responseKind: 'turbo-stream' })

          if (data.update_candidate_position !== undefined) {
            get(`/candidates/${candidateId}/premium_assignment/item?sgid=${data.update_candidate_position}`,
              { responseKind: 'turbo-stream' }
            )
          }

          if (data.add_candidate_position !== undefined) {
            get(`/candidates/${candidateId}/premium_assignment/new_item?sgid=${data.add_candidate_position}`,
              { responseKind: 'turbo-stream' }
            )
          }
        }
      }
    )
  }

  disconnect () {
    this.subscription.unsubscribe()
  }
}

export default SidebarController
